export const getContextualMenuIconButtonStyles = (_, { palette = {} }) => ({
  contextualMenuIconButtonContainer: {
    position: 'relative',
    '& .selected': {
      fontWeight: 'bold',
    },
    '& .icon': {
      color: palette.neutralSecondary,
      fontSize: '16px',
      margin: '5px 0px',
    },
    '& .icon-button': {
      padding: '0px 0px',
      backgroundColor: palette.neutralLighter,
      border: 'none',
      minWidth: '33px',
      height: '36px',
    },
    '& .icon-button:hover': {
      backgroundColor: palette.neutralQuaternary,
    },
  },
});
